import { VehicleModelWithInsurancesForD2CDto } from '@orcar/common';

/**
 * 선택한 일정에 예약 가능한 차량을 앞으로, 예약마감(availableCount 0) 차량을 뒤로 보낸다.
 * 같은 그룹 안에서는 서버가 준 순서를 유지한다(안정 정렬).
 */
export const sortAvailableFirst = (
  vehicleModels?: VehicleModelWithInsurancesForD2CDto[],
) =>
  vehicleModels &&
  [...vehicleModels].sort(
    (a, b) => Number(a.availableCount === 0) - Number(b.availableCount === 0),
  );
